export default __webpack_public_path__ + "static/media/defaultAvatar.3c7abeb6.svg";